import script from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=0ec48a21&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec48a21"]])

export default __exports__